/**
 * @file Automatically generated by barrelsby.
 */

export * from './breadcrumb.component';
